import React, { JSX } from "react";
import Link from "next/link";

import styles from "@/styles/components.module.scss";

interface Props {
    path_1?: string;
    path_2?: string;
    name_1?: string;
    name_2?: string | null;
    current?: string | null;
};

const Breadcrumbs = ({ current, path_1, path_2, name_1, name_2 }: Props): JSX.Element => {

    return (
        <div className={styles["breadcrumbs"]}>
            <div className={styles["breadcrumbs-link"]}>
                {path_1 && <Link href={path_1} >
                    {name_1}
                </Link>}
                {path_2 && <Link href={path_2} >
                    {name_2}
                </Link>}
                <span>{current}</span>
            </div>
        </div>
    );
};

export default Breadcrumbs;
